var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1827 l0 -82 559 -419 c307 -231 562 -419 566 -419 4 0 259 188 566 419 l559 419 0 82 0 83 -1125 0 -1125 0 0 -83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1120 l0 -412 29 19 c362 234 551 359 551 364 0 4 -116 93 -257 199 -142 107 -273 204 -290 218 l-33 24 0 -412z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960 1315 c-156 -117 -286 -217 -287 -222 -2 -4 127 -92 285 -195 l287 -187 3 205 c1 112 1 296 0 408 l-3 205 -285 -214z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 742 l-363 -237 0 -82 0 -83 1125 0 1125 0 0 83 0 82 -362 235 c-199 129 -367 234 -374 234 -6 -1 -91 -62 -190 -136 -98 -74 -184 -137 -190 -141 -6 -3 -98 59 -204 138 -107 80 -196 145 -199 144 -3 0 -169 -107 -368 -237z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon6);
export default __webpack_public_path__ + "static/media/nav-icon6.2b4f20781634076e14aee6eeb0b6126f.svg";
export { ForwardRef as ReactComponent };